var bstackComplaincePage = (function () {
  var headerElem, content, sidebarLinksParent, sidebarLinks, tocSect, mobileBtnDDElem, linksSideBar, opened, parentHeading, allHeading;
  return {
    init: init,
  };

  function init() {
    headerElem = document.getElementById("header-habitat"),
      content = document.querySelector('.bs-complaince__container'),
      sidebarLinksParent = document.querySelectorAll('.bs-complaince__toc-list ul li'),
      sidebarLinks = document.querySelectorAll('.bs-complaince__toc-list ul li a'),
      tocSect = document.querySelector('.bs-complaince__toc-container'),
      mobileBtnDDElem = document.querySelector('.bs-complaince__sidebar-btn'),
      linksSideBar = document.querySelector('.bs-complaince__sidebar'),
      parentHeading = document.querySelector('.bs-complaince__content'),
      allHeading = parentHeading.querySelectorAll('h4:not(.hide-toc-heading)'),
      opened = null;

    uiBindings();
  }

  function uiBindings() {
    function handleScrollAndResizeEvents() {
      stickyTocOnScroll();
      highlightToc();
    }

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

    if (sidebarLinks) {
      for (var i = 0; i < sidebarLinks.length; i++) {
        sidebarLinks[i].addEventListener('click', setActiveToc);
      }
    }

    for (var i = 0; i < allHeading.length; i++) {
      var clearInnerHeading = allHeading[i].innerHTML.replace(/\n|<.*?>/g, '');
      if (allHeading[i].nodeName == 'H4') {
        if (clearInnerHeading) {
          if (i == 0) {
            allHeading[i].setAttribute("id", "toc0");
          } else {
            allHeading[i].setAttribute("id", "toc" + i);
          }
        }
      }
    }

    if (mobileBtnDDElem) {
      mobileBtnDDElem.addEventListener('click', mobileMenuOnClickFn);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.bs-complaince__sidebar-btn') == null) {
        removeMobileMenuActiveClass();
      }
    });
  }

  function removeMobileMenuActiveClass() {
    mobileBtnDDElem.classList.remove('active');
    mobileBtnDDElem.nextElementSibling.classList.remove('dd-toggle');
  }

  function mobileMenuOnClickFn(e) {
    e.preventDefault();
    var that = this,
      menu = that.parentElement.lastChild.previousSibling;

    if (!opened) {
      opened = menu;
      opened.classList.toggle('dd-toggle');
      opened.previousElementSibling.classList.toggle('active');
    } else if (menu == opened) {
      menu.classList.toggle('dd-toggle');
      opened.previousElementSibling.classList.toggle('active');
      opened = null;
    } else {
      opened.classList.toggle('dd-toggle');
      opened.previousElementSibling.classList.toggle('active');
      removeMobileMenuActiveClass();
      opened = menu;
      opened.classList.toggle('dd-toggle');
      opened.previousElementSibling.classList.toggle('active');
    }
  }

  function stickyTocOnScroll() {
    if (window.innerWidth >= 980 && tocSect) {
      var footerHabitat = document.getElementById('footer-habitat'),
        sidebar = document.querySelector('.bs-complaince__toc'),
        sidebarBottom = sidebar.getBoundingClientRect().bottom,
        windowYOffset = window.pageYOffset;

      if (windowYOffset <= content.offsetTop) {
        if (content.classList.contains('section-sticky-top') || content.classList.contains('section-sticky-bottom')) {
          content.classList.remove('section-sticky-top', 'section-sticky-bottom');
        }
      } else if ((sidebarBottom - 131) <= 0) {
        if (content.classList.contains('section-sticky-top') || content.classList.contains('section-sticky-bottom')) {
          content.classList.remove('section-sticky-top', 'section-sticky-bottom');
        }
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + tocSect.offsetHeight) < (footerHabitat.offsetTop - 100))) {
        if (!content.classList.contains('section-sticky-top')) {
          content.classList.add('section-sticky-top');
        }
        if (content.classList.contains('section-sticky-bottom')) {
          content.classList.remove('section-sticky-bottom');
        }
      } else {
        if (content.classList.contains('section-sticky-top')) {
          content.classList.remove('section-sticky-top');
        }
        if (!content.classList.contains('section-sticky-bottom')) {
          content.classList.add('section-sticky-bottom');
        }
        // for left sidebar stuck class
        if (windowYOffset > footerHabitat.offsetTop - 200) {
          linksSideBar.classList.add('linkbar-sticky');
        } else {
          linksSideBar.classList.remove('linkbar-sticky');
        }
      }
    } else {
      content.classList.remove('section-sticky-top', 'section-sticky-bottom');
    }
  }

  function highlightToc() {
    if (window.innerWidth >= 980 && tocSect && content.classList.contains('section-sticky-top')) {
      var activeToc = document.querySelector(".bs-complaince__toc-list ul li a.active"),
        activeIndex = 0;

      for (var s = 0; s < sidebarLinks.length; s++) {
        var tocHeadingID = sidebarLinks[s].getAttribute("data-scrollto"),
          tocHeadingDom = document.querySelector(tocHeadingID);

        if (tocHeadingDom) {
          var tocHeadingDomRect = tocHeadingDom.getBoundingClientRect();
          if ((tocHeadingDomRect.top - 150) < 0) {
            activeIndex = s;
          }
        }
      }

      if (activeToc && activeToc.classList.contains('active')) {
        activeToc.classList.remove("active");
        var parentLi = sidebarLinks[activeIndex].parentElement;
        // If the clicked link is not inside a nested list
        if (parentLi.parentElement.tagName === 'UL' && parentLi.parentElement.parentElement.tagName !== 'LI') {
          parentLi.classList.remove('active');
        }
        // If the clicked link is inside a nested list, add 'active' to its grandparent list item
        if (parentLi.parentElement.parentElement && parentLi.parentElement.parentElement.tagName === 'LI') {
          parentLi.parentElement.parentElement.classList.remove('active');
        }
      }

      // Scroll the active link into view within the TOC
      sidebarLinks[activeIndex].scrollIntoView({ behavior: "smooth", block: "center" });

      setActiveTocParent(sidebarLinks[activeIndex]);
    }
  }

  function setActiveToc(event) {
    var that = event.target;
    setActiveTocParent(that);
  }

  function setActiveTocParent(activeToc) {
    for (var a = 0; a < sidebarLinksParent.length; a++) {
      sidebarLinksParent[a].classList.remove('active');
    }
    for (var b = 0; b < sidebarLinks.length; b++) {
      sidebarLinks[b].classList.remove('active');
    }
    activeToc.classList.add('active');
    var parentLi = activeToc.parentElement;
    // If the clicked link is not inside a nested list
    if (parentLi.parentElement.tagName === 'UL' && parentLi.parentElement.parentElement.tagName !== 'LI') {
      parentLi.classList.add('active');
    }
    // If the clicked link is inside a nested list, add 'active' to its grandparent list item
    if (parentLi.parentElement.parentElement && parentLi.parentElement.parentElement.tagName === 'LI') {
      parentLi.parentElement.parentElement.classList.add('active');
    }
  }
})();

bstackComplaincePage.init();